import script from "./AdminDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./AdminDashboardView.vue?vue&type=style&index=0&id=e3f2e284&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3f2e284"]])

export default __exports__